import blacktea from "../../../assets/images/blacktea.png";
import greentea from "../../../assets/images/greentea.jpg";
import whitetea from "../../../assets/images/whitetea.jpg";
import oolongtea from "../../../assets/images/oolongtea.png";
import puerhtea from "../../../assets/images/puerhtea.png";
import purpletea from "../../../assets/images/purpletea.jpg";
import matchatea from "../../../assets/images/matchatea.jpg";
import matetea from "../../../assets/images/matetea.jpg";
import herbaltea from "../../../assets/images/herbaltea.png";
import rooibostea from "../../../assets/images/rooibostea.png";

export const teaCards = [
  {
    src: blacktea,
    title: "Black Tea",
    description:
      "Fermented tea, bold flavor, dark liquor, high in invigorating caffeine.",
    id: "img1",
    tooltipTitle: "Black Tea",
    addButton: "+",
    minusButton: "-",
    saleType: "",
  },
  {
    src: greentea,
    title: "Green Tea",
    description: "Unoxidized tea, fresh, grassy, light flavor, good for focus.",
    id: "img2",
    tooltipTitle: "Green Tea",
    addButton: "+",
    minusButton: "-",
    saleType: "",
  },
  {
    src: whitetea,
    title: "White Tea",
    description: "Delicate, subtly sweet, minimally processed, light caffeine.",
    id: "img3",
    tooltipTitle: "White Tea",
    addButton: "+",
    minusButton: "-",
    saleType: "",
  },
  {
    src: oolongtea,
    title: "Oolong Tea",
    description:
      "Partially oxidized, complex, floral to bold, medium caffeine.",
    id: "img4",
    tooltipTitle: "Oolong Tea",
    addButton: "+",
    minusButton: "-",
    saleType: "50% OFF SUMMER SALE",
  },
  {
    src: puerhtea,
    title: "Pu-erh Tea",
    description:
      "Fermented, earthy, rich, smooth, dark, unique, aged, high caffeine.",
    id: "img5",
    tooltipTitle: "Pu-erh Tea",
    addButton: "+",
    minusButton: "-",
    saleType: "50% OFF SUMMER SALE",
  },
  {
    src: purpletea,
    title: "Purple Tea",
    description:
      "Unique color, fruity, clean taste, lower astringency, antioxidants.",
    id: "img6",
    tooltipTitle: "Purple Tea",
    addButton: "+",
    minusButton: "-",
    saleType: "",
  },
  {
    src: matchatea,
    title: "Matcha Tea",
    description: "Powdered, vibrant green, umami, concentrated, high caffeine.",
    id: "img7",
    tooltipTitle: "Matcha Tea",
    addButton: "+",
    minusButton: "-",
    saleType: "",
  },
  {
    src: matetea,
    title: "Mate Tea",
    description: "South American herb, earthy, stimulating, high caffeine.",
    id: "img8",
    tooltipTitle: "Mate Tea",
    addButton: "+",
    minusButton: "-",
    saleType: "",
  },
  {
    src: herbaltea,
    title: "Herbal Tea",
    description: "Plants steeped, diverse flavors, no caffeine, soothing.",
    id: "img9",
    tooltipTitle: "Herbal Tea",
    addButton: "+",
    minusButton: "-",
    saleType: "50% OFF SUMMER SALE",
  },
  {
    src: rooibostea,
    title: "Rooibos Tea",
    description: "South African, naturally sweet, red, caffeine-free, earthy.",
    id: "img10",
    tooltipTitle: "Rooibos Tea",
    addButton: "+",
    minusButton: "-",
    saleType: "",
  },
];
